import { render, staticRenderFns } from "./WidgetsReportQuotation.vue?vue&type=template&id=3607d5ce&scoped=true"
import script from "./WidgetsReportQuotation.vue?vue&type=script&lang=js"
export * from "./WidgetsReportQuotation.vue?vue&type=script&lang=js"
import style0 from "./WidgetsReportQuotation.vue?vue&type=style&index=0&id=3607d5ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3607d5ce",
  null
  
)

export default component.exports